// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Mxoz","title":"InfoRow_title__1ogbF"};